module.exports = __webpack_public_path__ + "static/location-based-timeclocks-deb6b1404c9a56fd4ce9c1c1ab4e12f7.png";